import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'

const EmptyWebhookSubscriptionsComponent = () => {
  return (
    <div
      data-testid="webhook-subscriptions-empty"
      css={tw`flex h-full w-full flex-col items-center justify-center gap-1`}
    >
      <Typography variant="subtitle1">No webhook subscriptions yet</Typography>
      <Typography variant="body2" css={tw`text-shades-500`}>
        Add a subscription to start sending this customer event notifications.
      </Typography>
    </div>
  )
}

export const EmptyWebhookSubscriptions = memo(EmptyWebhookSubscriptionsComponent)
